import { useEffect } from 'react'
import { useRouter } from 'next/router'

const CONFIRM_MESSAGE =
  'You have unsaved changes that will be lost if you decide to continue.\nAre you sure you want to leave this page?'

const useRouteChangeConfirmation = (shouldConfirm: () => boolean, message: string = CONFIRM_MESSAGE) => {
  const router = useRouter()

  useEffect(() => {
    const handleWindowClose = (e?: any) => {
      if (shouldConfirm()) {
        e.preventDefault()
        e.returnValue = message
        return message
      }
    }

    const checkConfirm = () => {
      if (shouldConfirm()) {
        if (!window.confirm(message)) {
          router.events.emit('routeChangeError')
          throw 'routeChange aborted.'
        }
      }
    }

    router.events.on('routeChangeStart', checkConfirm)
    window.addEventListener('beforeunload', handleWindowClose)

    return () => {
      router.events.off('routeChangeStart', checkConfirm)
      window.removeEventListener('beforeunload', handleWindowClose)
    }
  }, [router, shouldConfirm, message])
}

export default useRouteChangeConfirmation
